export default "__VITE_ASSET__R1v5wZGl__"